import * as React from 'react';
/**
 *
 * Original name: switcher
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1079
 *
 */
export const SwitcherLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m12 6.533 4.234 4.011 1.032-1.089L12 4.467 6.734 9.455l1.032 1.09L12 6.532Zm0 10.934-4.234-4.011-1.032 1.088L12 19.534l5.266-4.989-1.032-1.088L12 17.466Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
